import PropTypes from 'prop-types';

const GuidesIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.75 13.5c.641 0 1.17.483 1.242 1.104L7 14.75V16h1.25a1.25 1.25 0 0 1 .146 2.492l-.146.008H7v1.25a1.25 1.25 0 0 1-2.492.146L4.5 19.75V18.5H3.25a1.25 1.25 0 0 1-.146-2.492L3.25 16H4.5v-1.25c0-.69.56-1.25 1.25-1.25zm0-10c.641 0 1.17.483 1.242 1.104L7 4.75V6h1.25a1.25 1.25 0 0 1 .146 2.492L8.25 8.5H7v1.25a1.25 1.25 0 0 1-2.492.146L4.5 9.75V8.5H3.25a1.25 1.25 0 0 1-.146-2.492L3.25 6H4.5V4.75c0-.69.56-1.25 1.25-1.25zm12.5 10c.641 0 1.17.483 1.242 1.104l.008.146V16h1.25a1.25 1.25 0 0 1 .146 2.492l-.146.008H19.5v1.25a1.25 1.25 0 0 1-2.492.146L17 19.75V18.5h-1.25a1.25 1.25 0 0 1-.146-2.492L15.75 16H17v-1.25c0-.69.56-1.25 1.25-1.25zm0-10c.641 0 1.17.483 1.242 1.104l.008.146V6h1.25a1.25 1.25 0 0 1 .146 2.492l-.146.008H19.5v1.25a1.25 1.25 0 0 1-2.492.146L17 9.75V8.5h-1.25a1.25 1.25 0 0 1-.146-2.492L15.75 6H17V4.75c0-.69.56-1.25 1.25-1.25z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

GuidesIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

GuidesIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default GuidesIcon;
